var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-wrapper"}},[_c('vue-progress-bar'),_vm._v(" "),_c('header-bar',{attrs:{"isConnected":_vm.isConnected}}),_vm._v(" "),_c('side-bar'),_vm._v(" "),_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1692ee23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Layout.vue
// module id = l+A8
// module chunks = 17